module.exports = __webpack_public_path__ + "assets/img/del.513aedd0.png";